import * as Sentry from '@sentry/react'

export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD, // Active prod only
    initialScope: {
      tags: { app: 'tutor' },
    },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

type ErrorType =
  | 'general-error'
  | 'not-found'
  | 'unauthorized'
  | 'forbidden'
  | 'maintenance'

export function reportError(errorType: ErrorType, error?: Error) {
  Sentry.withScope((scope) => {
    scope.setTag('error.type', errorType)
    scope.setLevel(errorType === 'general-error' ? 'error' : 'warning')

    if (error) {
      Sentry.captureException(error)
    } else {
      Sentry.captureMessage(`Error page displayed: ${errorType}`)
    }
  })
}

export { Sentry }
